import { Button } from "@ui/Button";

export const NewBoardButton = (props: { onClick: () => void }) => {
	return (
		<Button
			variant="tertiary"
			theme="monochrome"
			symbol="bookmark_add"
			onClick={props.onClick}
		>
			New board
		</Button>
	);
};
